// All website content extracted from stallionguards.com

export const company = {
  name: "Stallion Bulktech",
  tagline: "Industrial Machine Guarding Manufacturer",
  description: "Stallion Bulktech is among India's leading Industrial Machine Guarding Manufacturers and Material Handling Solutions Provider, delivering conveyor and rotating equipment guards, perimeter and interlocked safety systems, along with wear resistance and dust suppression technologies. Engineered for harsh industrial environments, our solutions reduce wear and tear, control dust exposure, improve equipment life, and minimize unplanned downtime. From site assessment to installation, we deliver end-to-end solutions tailored to your machinery and operating conditions.",
  phone: "+91 7041365465",
  phone2: "+91 9825585606",
  email: "info@stallionbulktech.com",
  address: "Plot No 4, Gatrad – Vanch Road, Gatrad, Ahmedabad - 382449"
};

export const stats = [
  { label: "Securing Industries Since", value: "2018", isStatic: true },
  { label: "Zero-Contact Guarding Systems", value: "360°", isStatic: true },
  { label: "Safety Compliance Across Installations", value: "99%", isStatic: false },
  { label: "Industrial Facilities Secured", value: "500+", isStatic: false }
];

export const industries = [
  { name: "Mining", image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/m8gt560u_mining.png" },
  { name: "Pharma", image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/dwx334zh_pharma.png" },
  { name: "Power Plant", image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/8ffzus1u_powerplant.png" },
  { name: "Refinery", image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/0tjk3v5f_refinery.jpg" },
  { name: "Steel", image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/gu50ywgk_steel.jpeg" },
  { name: "Textile", image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/8ayd74dy_Textile.png" },
  { name: "Automobile", image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/3xggxe5h_Automobile.png" },
  { name: "Cement", image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/tb72x77e_Cement.png" },
  { name: "Chemical", image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/neenlp5h_Chemical.png" },
  { name: "Fertilizer", image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/0ntiluw9_Fertilizer.png" },
  { name: "FMCG", image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/ah36nv4q_Food.jpg" }
];

export const clients = [
  // User-specified featured order
  { name: "JSW Group", logo: "https://stallionguards.com/wp-content/uploads/clients/client-jsw-group.jpg" },
  { name: "Adani Wilmar", logo: "https://stallionguards.com/wp-content/uploads/clients/client-adani-wilmar.jpg" },
  { name: "Adani Power", logo: "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/8ywal77r_image.png" },
  { name: "Vedanta Sesa", logo: "https://stallionguards.com/wp-content/uploads/clients/client-vedanta-sesa.jpg" },
  { name: "Shree Renuka", logo: "https://stallionguards.com/wp-content/uploads/clients/client-shree-renuka.jpg" },
  { name: "Nirma Ltd", logo: "https://stallionguards.com/wp-content/uploads/clients/client-nirma-ltd.jpg" },
  { name: "Jindal Saw", logo: "https://stallionguards.com/wp-content/uploads/clients/client-jindal-saw.jpg" },
  { name: "JK Lakshmi", logo: "https://stallionguards.com/wp-content/uploads/clients/client-jk-lakshmi.jpg" },
  { name: "Amul", logo: "https://stallionguards.com/wp-content/uploads/clients/client-amul.jpg" },
  { name: "Amazon", logo: "https://stallionguards.com/wp-content/uploads/clients/client-amazon.jpg" },
  { name: "AIA Engineering", logo: "https://stallionguards.com/wp-content/uploads/clients/client-aia-engineering.jpg" },
  { name: "Coca Cola", logo: "https://stallionguards.com/wp-content/uploads/clients/client-coca-cola.jpg" },
  // Remaining clients (alphabetical)
  { name: "Aditya Grasim", logo: "https://stallionguards.com/wp-content/uploads/clients/client-aditya-grasim.jpg" },
  { name: "Aditya Hindalco", logo: "https://stallionguards.com/wp-content/uploads/clients/client-aditya-hindalco.jpg" },
  { name: "BIC Cello", logo: "https://stallionguards.com/wp-content/uploads/clients/client-bic-cello.jpg" },
  { name: "Carlsberg", logo: "https://stallionguards.com/wp-content/uploads/clients/client-carlsberg.jpg" },
  { name: "DCM Shriram", logo: "https://stallionguards.com/wp-content/uploads/clients/client-dcm-shriram.jpg" },
  { name: "Endurance", logo: "https://stallionguards.com/wp-content/uploads/clients/client-endurance.jpg" },
  { name: "GEPIL", logo: "https://stallionguards.com/wp-content/uploads/clients/client-gepil.jpeg" },
  { name: "Helios Concrew", logo: "https://stallionguards.com/wp-content/uploads/clients/client-helios-concrew.jpg" },
  { name: "Hindustan Infrastructure", logo: "https://stallionguards.com/wp-content/uploads/clients/client-hindustan-infrastructure.jpg" },
  { name: "Hyfun", logo: "https://stallionguards.com/wp-content/uploads/clients/client-hyfun.jpeg" },
  { name: "IMC Ltd", logo: "https://stallionguards.com/wp-content/uploads/clients/client-imc-ltd.jpg" },
  { name: "Ingersoll Rand", logo: "https://stallionguards.com/wp-content/uploads/clients/client-ingersoll-rand.jpg" },
  { name: "ITC Limited", logo: "https://stallionguards.com/wp-content/uploads/clients/client-itc-limited.jpg" },
  { name: "Jindal Stainless", logo: "https://stallionguards.com/wp-content/uploads/clients/client-jindal-stainless.jpg" },
  { name: "Kirloskar Ferrous", logo: "https://stallionguards.com/wp-content/uploads/clients/client-kirloskar-ferrous.jpg" },
  { name: "Luthra Group", logo: "https://stallionguards.com/wp-content/uploads/clients/client-luthra-group.jpeg" },
  { name: "Marathon Electric", logo: "https://stallionguards.com/wp-content/uploads/clients/client-marathon-electric.jpg" },
  { name: "Morgan Materials", logo: "https://stallionguards.com/wp-content/uploads/clients/client-morgan-materials.jpg" },
  { name: "Murugappa", logo: "https://stallionguards.com/wp-content/uploads/clients/client-murugappa.jpg" },
  { name: "Nilon Valves", logo: "https://stallionguards.com/wp-content/uploads/clients/client-nilon-valves.jpg" },
  { name: "Power Drive", logo: "https://stallionguards.com/wp-content/uploads/clients/client-power-drive.jpg" },
  { name: "PPI Pumps", logo: "https://stallionguards.com/wp-content/uploads/clients/client-ppi-pumps.jpg" },
  { name: "Praj Industries", logo: "https://stallionguards.com/wp-content/uploads/clients/client-praj-industries.jpg" },
  { name: "Reckitt", logo: "https://stallionguards.com/wp-content/uploads/clients/client-reckitt.jpg" },
  { name: "Regal Rexnord", logo: "https://stallionguards.com/wp-content/uploads/clients/client-regal-rexnord.jpg" },
  { name: "RHI Magnesita", logo: "https://stallionguards.com/wp-content/uploads/clients/client-rhi-magnesita.jpg" },
  { name: "Roki Unominda", logo: "https://stallionguards.com/wp-content/uploads/clients/client-roki-unominda.jpg" },
  { name: "Sajjan India", logo: "https://stallionguards.com/wp-content/uploads/clients/client-sajjan-india.jpg" },
  { name: "Schott Glass", logo: "https://stallionguards.com/wp-content/uploads/clients/client-schott-glass.jpg" },
  { name: "Silver Foundry", logo: "https://stallionguards.com/wp-content/uploads/clients/client-silver-foundry.jpg" },
  { name: "SPX Flow", logo: "https://stallionguards.com/wp-content/uploads/clients/client-spx-flow.jpg" },
  { name: "TLS Turbo", logo: "https://stallionguards.com/wp-content/uploads/clients/client-tls-turbo.jpeg" },
  { name: "Wed Motors", logo: "https://stallionguards.com/wp-content/uploads/clients/client-wed-motors.jpg" },
  { name: "Welspun Textiles", logo: "https://stallionguards.com/wp-content/uploads/clients/client-welspun-textiles.jpg" }
];

export const aboutContent = {
  title: "Execution-First Engineering",
  description: "Stallion Bulktech is among India's leading Industrial Machine Guarding and Material Handling Solutions Provider, delivering conveyor and rotating equipment guards, perimeter and interlocked safety solutions, along with advanced wear resistance and dust suppression technologies. Our product range is designed for high-load industrial environments including mining, cement, power, and bulk material handling, where equipment reliability and operator safety are critical. By combining robust engineering with practical on-site requirements, we build systems that not only protect machinery but also enhance overall operational efficiency.",
  description2: "Engineered for harsh and demanding conditions, our solutions help reduce wear and tear, control dust exposure, and extend equipment life while minimizing unplanned downtime. From detailed site assessment and risk evaluation to custom design, manufacturing, and installation, we deliver end-to-end solutions tailored to each facility's machinery, layout, and operating conditions. The focus is not just on compliance, but on creating durable, low-maintenance systems that perform consistently in real-world industrial operations.",
  vision: "To be the most trusted partner for machine guarding, dust suppression, and wear resistance solutions in high-load industries. We aim to set the standard for systems that perform reliably in real operating conditions. Our focus is on improving plant safety, equipment life, and operational consistency at scale.",
  mission: "To engineer and deliver practical solutions that protect machinery, control dust, and reduce wear across industrial operations. We work closely with each facility to design systems that fit site conditions and operational demands. Our approach focuses on reducing downtime, lowering maintenance effort, and ensuring long-term performance."
};

export const values = [
  {
    title: "Quality",
    description: "We design and manufacture machine guarding and material handling solutions built for high load, high wear environments. Every system is engineered for durability, consistent performance, and minimal maintenance in demanding industrial conditions."
  },
  {
    title: "Flexibility",
    description: "No two plants operate the same. We deliver solutions tailored to your machinery, layout, and site conditions, from assessment and risk evaluation to custom design, manufacturing, and installation."
  },
  {
    title: "Experience",
    description: "Our experience across mining, cement, power, and bulk material handling industries allows us to solve real operational challenges. We build systems that perform reliably in tough, continuous-use environments."
  },
  {
    title: "Expertise",
    description: "We specialize in conveyor and rotating equipment guarding, perimeter and interlocked safety systems, along with wear resistance and dust suppression solutions, ensuring complete operational protection."
  },
  {
    title: "Compliance",
    description: "We offer the most reliable and maintenance friendly machine guarding solution in compliance with ISO India and BIS safety guarding regulations."
  },
  {
    title: "Client Satisfaction",
    description: "We focus on outcomes that matter. Reduced downtime, controlled dust, extended equipment life, and reliable performance through durable, low maintenance systems."
  }
];

export const productCategories = [
  "Rotating Equipment Guards",
  "Conveyor Guards",
  "Perimeter Barrier Guards",
  "Workshop Machine Guards",
  "Smart Guards",
  "Modular Rain Guards",
  "Wear Resistance",
  "Dust Suppression System"
];

export const products = [
  {
    id: 1,
    name: "Belt / Chain / Gear Drive Guards",
    slug: "belt-chain-gear-drive-guards",
    category: "Rotating Equipment Guards",
    shortDescription: "Comprehensive protection for belt drives, chain drives, and gear systems ensuring zero-contact safety.",
    image: "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/5kudrdkv_Belt%20%3A%20Chain%20%3A%20Gear%20Drive%20Guards.jpeg",
    images: [
      "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/5kudrdkv_Belt%20%3A%20Chain%20%3A%20Gear%20Drive%20Guards.jpeg",
      "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/0o5ei0i7_Belt%20%3A%20Chain%20%3A%20Gear%20Drive%20Guards%202.jpeg",
      "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/28hab181_Belt%20%3A%20Chain%20%3A%20Gear%20Drive%20Guards%203.jpeg"
    ],
    features: [
      "360° zero-contact protection for belt, chain, and gear drives",
      "Designed with angle framing for maximum durability",
      "Perforated sheet allows inspection without removal",
      "Ergonomic handles for easy installation and removal",
      "Lightweight construction for single or two-person handling",
      "Powder coated for extended shelf life"
    ],
    applications: [
      "Industrial machinery belt drives",
      "Chain drive systems",
      "Gear reduction units",
      "Power transmission equipment"
    ]
  },
  {
    id: 2,
    name: "Compressor / Pump Guards",
    slug: "compressor-pump-guards",
    category: "Rotating Equipment Guards",
    shortDescription: "Robust safety guards designed for compressors and pumps with easy maintenance access.",
    image: "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/vvr4m0xg_compressor%20guard.png",
    features: [
      "Complete protection for compressor and pump units",
      "Easy-access design for routine maintenance",
      "ISI standard heavy-duty steel construction",
      "Quick removal and reassembly within minutes",
      "Unique Identification Number (UIN) for easy tracking",
      "Compliant with ISO India safety standards"
    ],
    applications: [
      "Air compressors",
      "Centrifugal pumps",
      "Positive displacement pumps",
      "Hydraulic pump systems"
    ]
  },
  {
    id: 3,
    name: "Coupling Guards",
    slug: "coupling-guards",
    category: "Rotating Equipment Guards",
    shortDescription: "Specialized guards for flexible and rigid couplings providing complete safety coverage.",
    image: "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/dwzo39w5_Coupling%20Guards%201%20-%20Stallion%20Bulktech.jpeg",
    images: [
      "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/dwzo39w5_Coupling%20Guards%201%20-%20Stallion%20Bulktech.jpeg",
      "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/iqc5nuwt_Coupling%20Guards%202%20-%20Stallion%20Bulktech.jpeg"
    ],
    features: [
      "360° protection for all coupling types",
      "Split design for easy installation without disassembly",
      "Transparent sections for visual inspection",
      "Minimal space requirement",
      "No exposed pinch points",
      "Custom sizing available"
    ],
    applications: [
      "Flexible couplings",
      "Rigid couplings",
      "Fluid couplings",
      "Universal joints"
    ]
  },
  {
    id: 4,
    name: "Flange Bearing Guards",
    slug: "flange-bearing-guards",
    category: "Rotating Equipment Guards",
    shortDescription: "Precision-engineered guards for flange-mounted bearings with optimal protection.",
    image: "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/l3ryh093_flange%20bearing.png",
    features: [
      "Designed specifically for flange-mounted bearings",
      "Compact design fits minimum space",
      "Easy inspection through perforated panels",
      "Quick-release mechanism",
      "Durable powder coating",
      "Maintenance-friendly design"
    ],
    applications: [
      "Flange bearings on conveyors",
      "Pillow block bearings",
      "Take-up bearing units",
      "Mounted bearing assemblies"
    ]
  },
  {
    id: 5,
    name: "Pump Gland Guards",
    slug: "pump-gland-guards",
    category: "Rotating Equipment Guards",
    shortDescription: "Protective guards for pump glands and sealing areas with easy maintenance access.",
    image: "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/q2a93wb7_Pump%20Gland%20Guard%201.png",
    images: [
      "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/q2a93wb7_Pump%20Gland%20Guard%201.png",
      "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/clmpf5qh_Pump%20Gland%20Guard%202.png"
    ],
    features: [
      "Protection for pump gland areas",
      "Quick access for seal maintenance",
      "Corrosion-resistant materials",
      "Lightweight yet robust",
      "Tool-free removal",
      "Custom fit for various pump models"
    ],
    applications: [
      "Centrifugal pump glands",
      "Process pump seals",
      "Chemical pump glands",
      "Water pump sealing areas"
    ]
  },
  {
    id: 6,
    name: "Conveyor Side Guards",
    slug: "conveyor-side-guards",
    category: "Conveyor Guards",
    shortDescription: "Comprehensive side protection for conveyor systems preventing accidents and material spillage.",
    image: "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/ctn7f0e1_conveyor%20guard.png",
    features: [
      "Complete side coverage for conveyor belts",
      "Prevents material spillage and accidents",
      "Modular design for easy extension",
      "Weather-resistant construction",
      "Easy installation on existing conveyors",
      "Adjustable height options"
    ],
    applications: [
      "Belt conveyors",
      "Material handling conveyors",
      "Mining conveyors",
      "Manufacturing line conveyors"
    ]
  },
  {
    id: 7,
    name: "Conveyor Canopy",
    slug: "conveyor-canopy",
    category: "Conveyor Guards",
    shortDescription: "Weather protection and safety canopy for conveyor systems with robust construction.",
    image: "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/10d44kdl_Conveyor%20Canopy%201.png",
    images: [
      "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/10d44kdl_Conveyor%20Canopy%201.png",
      "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/3ghuath3_Conveyor%20Canopy%202.png",
      "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/2epopfeh_Conveyor%20Canopy%203.png"
    ],
    features: [
      "Complete weather protection for conveyors",
      "UV-resistant materials",
      "Modular sections for any length",
      "Integrated safety access points",
      "Drainage system for water runoff",
      "Low maintenance design"
    ],
    applications: [
      "Outdoor conveyor systems",
      "Mining industry conveyors",
      "Port material handling",
      "Cement plant conveyors"
    ]
  },
  {
    id: 8,
    name: "Pulley Guards",
    slug: "pulley-guards",
    category: "Conveyor Guards",
    shortDescription: "Specialized guards for conveyor pulleys ensuring complete nip point protection.",
    image: "https://stallionguards.com/wp-content/uploads/products/pulley-guards-1-uai-1080x607.jpg",
    features: [
      "Complete nip point protection",
      "Designed for head, tail, and bend pulleys",
      "Easy access for belt tracking",
      "No contact with moving parts",
      "Robust angle frame construction",
      "Powder coated finish"
    ],
    applications: [
      "Head pulleys",
      "Tail pulleys",
      "Bend pulleys",
      "Snub pulleys"
    ]
  },
  {
    id: 9,
    name: "Return Idler Guards",
    slug: "return-idler-guards",
    category: "Conveyor Guards",
    shortDescription: "Guards for return idler rollers providing comprehensive underside protection.",
    image: "https://stallionguards.com/wp-content/uploads/products/return-idler-guards-1-uai-1080x607.jpg",
    features: [
      "Protection for return side idlers",
      "Prevents material buildup",
      "Easy cleaning access",
      "Modular sections for long conveyors",
      "Corrosion-resistant construction",
      "Quick installation"
    ],
    applications: [
      "Return idler rollers",
      "Conveyor return sides",
      "Impact idler areas",
      "Training idler sections"
    ]
  },
  {
    id: 10,
    name: "Workstation Barrier Guards",
    slug: "workstation-barrier-guards",
    category: "Perimeter Barrier Guards",
    shortDescription: "Modular barrier systems for workstation protection and area segregation.",
    image: "https://stallionguards.com/wp-content/uploads/products/workstation-barrier-guards-1-uai-1080x607.jpg",
    features: [
      "Modular panel system",
      "Creates safe work zones",
      "Easy reconfiguration",
      "Integrated access gates",
      "Powder coated steel construction",
      "Various height options"
    ],
    applications: [
      "Production workstations",
      "Assembly areas",
      "Quality control zones",
      "Restricted access areas"
    ]
  },
  {
    id: 11,
    name: "Safety Fencing",
    slug: "safety-fencing",
    category: "Perimeter Barrier Guards",
    shortDescription: "Comprehensive safety fencing solutions for perimeter and area protection.",
    image: "https://stallionguards.com/wp-content/uploads/products/safety-fencing-1-uai-1080x607.jpg",
    features: [
      "Modular fencing system",
      "Easy installation and relocation",
      "Various mesh sizes available",
      "Gate integration options",
      "Durable outdoor finish",
      "Compliant with safety standards"
    ],
    applications: [
      "Machinery perimeter protection",
      "Hazardous area demarcation",
      "Warehouse safety zones",
      "Plant perimeter fencing"
    ]
  },
  {
    id: 12,
    name: "Modular Handrails",
    slug: "modular-handrails",
    category: "Perimeter Barrier Guards",
    shortDescription: "Flexible modular handrail systems for platforms, walkways, and elevated areas.",
    image: "https://stallionguards.com/wp-content/uploads/products/modular-handrails-1-uai-1080x607.jpg",
    features: [
      "Modular pipe and fitting system",
      "Easy configuration for any layout",
      "Compliant with fall protection standards",
      "Corrosion-resistant components",
      "Quick assembly without welding",
      "Adjustable heights"
    ],
    applications: [
      "Platform handrails",
      "Walkway barriers",
      "Mezzanine protection",
      "Stairway handrails"
    ]
  },
  {
    id: 13,
    name: "Lathe Machine Guards",
    slug: "lathe-machine-guards",
    category: "Workshop Machine Guards",
    shortDescription: "Precision guards for lathe machines providing operator protection with visibility.",
    image: "https://stallionguards.com/wp-content/uploads/products/lathe-machine-guards-1-uai-1080x607.jpg",
    features: [
      "Designed for various lathe sizes",
      "Transparent panels for operation visibility",
      "Quick-access hinged design",
      "Chip and coolant containment",
      "Robust frame construction",
      "Easy retrofitting to existing machines"
    ],
    applications: [
      "CNC lathes",
      "Manual lathes",
      "Turret lathes",
      "Production lathes"
    ]
  },
  {
    id: 14,
    name: "Drill Machine Guards",
    slug: "drill-machine-guards",
    category: "Workshop Machine Guards",
    shortDescription: "Safety guards for drill machines protecting operators from rotating parts and debris.",
    image: "https://stallionguards.com/wp-content/uploads/products/drill-machine-guards-1-uai-1080x607.jpg",
    features: [
      "Complete protection from rotating parts",
      "Adjustable for different drill sizes",
      "Clear panels for visibility",
      "Chip deflection system",
      "Easy access for tool changes",
      "Sturdy construction"
    ],
    applications: [
      "Bench drill machines",
      "Pillar drills",
      "Radial drills",
      "Multi-spindle drills"
    ]
  },
  {
    id: 15,
    name: "Milling Machine Guards",
    slug: "milling-machine-guards",
    category: "Workshop Machine Guards",
    shortDescription: "Comprehensive protection for milling machines with easy access for operation.",
    image: "https://stallionguards.com/wp-content/uploads/products/milling-machine-guards-2-uai-1080x607.jpg",
    features: [
      "Full enclosure for milling operations",
      "Transparent sections for monitoring",
      "Hinged access panels",
      "Coolant and chip management",
      "Fits various milling machine types",
      "Durable construction"
    ],
    applications: [
      "Vertical milling machines",
      "Horizontal milling machines",
      "CNC mills",
      "Universal milling machines"
    ]
  },
  {
    id: 16,
    name: "Foot Mounted Motor Guards",
    slug: "foot-mounted-motor-guards",
    category: "Modular Rain Guards",
    shortDescription: "Weather protection guards for foot-mounted motors with ventilation.",
    image: "https://stallionguards.com/wp-content/uploads/products/foot-mounted-motor-guards-1-uai-1080x607.jpg",
    features: [
      "Complete weather protection",
      "Integrated ventilation system",
      "Custom sizing for all motor sizes",
      "UV and corrosion resistant",
      "Easy installation",
      "Drainage provisions"
    ],
    applications: [
      "Outdoor foot-mounted motors",
      "Pump motors",
      "Fan motors",
      "Conveyor drive motors"
    ]
  },
  {
    id: 17,
    name: "Flange Mounted Motor Guards",
    slug: "flange-mounted-motor-guards",
    category: "Modular Rain Guards",
    shortDescription: "Rain and weather protection for flange-mounted motors ensuring longevity.",
    image: "https://stallionguards.com/wp-content/uploads/products/flange-mounted-motor-guards-1-uai-1080x607.jpg",
    features: [
      "Protects flange-mounted motors from weather",
      "Adequate cooling ventilation",
      "Powder coated for durability",
      "Custom designs available",
      "Easy maintenance access",
      "Lightweight construction"
    ],
    applications: [
      "Vertical pump motors",
      "Flange-mounted drive motors",
      "Agitator motors",
      "Mixer motors"
    ]
  },
  {
    id: 20,
    name: "Ceramic Tiles High Aluminium (Liners)",
    slug: "ceramic-tiles-high-aluminium-liners",
    category: "Wear Resistance",
    shortDescription: "High alumina ceramic liners engineered for extreme wear environments, delivering long service life and reduced maintenance in bulk handling systems.",
    image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/2pb32w9p_CERAMIC%20TILES%20HIGH%20ALUMINIUM%20%28LINERS%29%201%20-%20Stallion%20Bulktech.png",
    images: [
      "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/2pb32w9p_CERAMIC%20TILES%20HIGH%20ALUMINIUM%20%28LINERS%29%201%20-%20Stallion%20Bulktech.png",
      "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/k403uxin_CERAMIC%20TILES%20HIGH%20ALUMINIUM%20%28LINERS%29%202%20-%20Stallion%20Bulktech.png"
    ],
    features: [
      "Extremely high hardness (near diamond level) for superior wear resistance",
      "Excellent resistance to abrasion, corrosion, and high temperatures",
      "Chemically inert to most industrial substances",
      "Customizable shapes and sizes for precise equipment fit",
      "Strong bonding and installation options for long-term durability",
      "Reduces downtime, maintenance frequency, and operating costs"
    ],
    applications: [
      "Coal handling systems in power plants",
      "Mining and mineral processing equipment",
      "Cement plant hoppers, chutes, and cyclones",
      "Steel industry material handling zones",
      "Conveyor transfer points and liners",
      "Any high-wear bulk material handling equipment"
    ]
  },
  {
    id: 21,
    name: "Ceramic Pulley Lagging",
    slug: "ceramic-pulley-lagging",
    category: "Wear Resistance",
    shortDescription: "Ceramic-in-rubber pulley lagging designed to maximize grip, eliminate slippage, and extend conveyor system life in harsh conditions.",
    image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/gm9z6pws_Ceramic%20Pulley%20Lagging%20-%20Stallion%20Bulktech.png",
    features: [
      "High coefficient of friction for superior belt grip (wet, dry, or muddy conditions)",
      "Ceramic tile reinforcement for extreme wear resistance",
      "Prevents belt slippage and reduces need for over-tensioning",
      "Self-cleaning surface reduces material buildup",
      "Extends pulley, belt, and bearing life",
      "Easy installation with chemically bonded rubber backing"
    ],
    applications: [
      "Conveyor drive and tail pulleys in mining operations",
      "Coal, iron ore, and limestone handling systems",
      "Cement and steel plant conveyors",
      "Wet and high-moisture material handling environments",
      "Heavy-duty bulk material conveying systems",
      "Areas prone to belt slippage and high abrasion"
    ]
  },
  {
    id: 22,
    name: "Ceramic Pad Lagging",
    slug: "ceramic-pad-lagging",
    category: "Wear Resistance",
    shortDescription: "Modular ceramic pad lagging designed to deliver high traction, easy replacement, and superior wear resistance for conveyor pulleys.",
    image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/tnaxm59b_Ceramic%20Pad%20Lagging%20-%20Stallion%20Bulktech.png",
    features: [
      "High friction surface ensures strong belt grip and reduced slippage",
      "Ceramic tile pads provide excellent abrasion resistance",
      "Modular design allows quick and easy replacement of worn sections",
      "Durable rubber backing absorbs impact and resists damage",
      "Performs reliably in wet, muddy, and abrasive conditions",
      "Reduces maintenance time and extends pulley life"
    ],
    applications: [
      "Conveyor pulleys in mining and bulk material handling",
      "Coal, cement, and mineral processing plants",
      "High-impact and high-abrasion zones",
      "Wet or contaminated conveying environments",
      "Retrofit solutions for worn or slipping pulleys",
      "Operations requiring fast maintenance and minimal downtime"
    ]
  },
  {
    id: 23,
    name: "Wind Fence",
    slug: "wind-fence",
    category: "Dust Suppression System",
    shortDescription: "Passive windscreen system that reduces wind velocity and controls dust emissions around open material handling areas.",
    image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/lwtb66r7_%20Wind%20Fence%201%20-%20stallion%20bulktech.png",
    images: [
      "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/lwtb66r7_%20Wind%20Fence%201%20-%20stallion%20bulktech.png",
      "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/itf7fbvy_%20Wind%20Fence%202%20-%20stallion%20bulktech.png"
    ],
    features: [
      "Reduces wind velocity by up to 75% to control fugitive dust",
      "Passive system—no power, no daily operation, minimal maintenance",
      "Durable UV-resistant polyester fabric for harsh outdoor conditions",
      "Porous design balances airflow to prevent turbulence and dust lift",
      "Cost-effective alternative to enclosed storage structures",
      "Available in multiple porosity options (30% & 50%) for site-specific performance"
    ],
    applications: [
      "Material stockpiles in mining and bulk handling sites",
      "Conveyor transfer points and stack-out areas",
      "Truck and rail loading/unloading zones",
      "Vibrating screens and grizzlies",
      "Open dump sites and load-out silos",
      "Cement, coal, steel, and mineral processing plants"
    ],
    collaborator: {
      name: "Dust Solutions Inc. (DSI)",
      url: "https://nodust.com/solutions/wind-fence/"
    }
  },
  {
    id: 24,
    name: "Dry Fog",
    slug: "dry-fog",
    category: "Dust Suppression System",
    shortDescription: "Dry fog dust suppression system that captures airborne dust at the source using ultra-fine droplets without wetting the material.",
    image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/ind21kzu_Dry%20Fog%201%20-%20Stallion%20Bulktech.png",
    images: [
      "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/ind21kzu_Dry%20Fog%201%20-%20Stallion%20Bulktech.png",
      "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/fx662cz0_Dry%20Fog%202%20-%20Stallion%20Bulktech.png"
    ],
    features: [
      "Ultrasonic dry fog (1–10 micron) captures fine dust (PM10 & PM2.5)",
      "Agglomerates dust particles and forces them to settle at source",
      "Minimal water usage with no material saturation (≤0.05%)",
      "Targets dust directly, not the bulk material",
      "Low operating and maintenance cost",
      "Effective for enclosed or controlled dust zones"
    ],
    applications: [
      "Conveyor transfer points and loading zones",
      "Crushers, screens, and grizzlies",
      "Coal, cement, and mineral processing plants",
      "Truck and rail loading/unloading areas",
      "Stockpile discharge and dump points",
      "Any enclosed or semi-enclosed dust-generating process"
    ],
    collaborator: {
      name: "Dust Solutions Inc. (DSI)",
      url: "https://nodust.com/solutions/dry-fog-solutions/"
    }
  },
  {
    id: 25,
    name: "NESCO High Pressure Mist",
    slug: "high-pressure-mist",
    category: "Dust Suppression System",
    shortDescription: "High-pressure mist system engineered for precise dust control with minimal water usage and zero impact on material quality.",
    image: "https://customer-assets.emergentagent.com/job_guards-premium/artifacts/x4cof6ou_Nesco%20High%20Pressure%20Mist%20-%20Stallion%20Bulktech.png",
    features: [
      "High-pressure atomization (13–15 bar) for fine mist and efficient dust suppression",
      "Controlled moisture addition (≤0.5%) to avoid product degradation",
      "Automated system with PLC/SCADA integration for real-time control",
      "Smart flow adjustment based on dust levels and material conditions",
      "Robust skid-mounted pump with dry-run protection and filtration system",
      "Zonal design for targeted application across crushing and handling circuits"
    ],
    applications: [
      "Crushing and screening plants",
      "Conveyor transfer points and stackers",
      "Mining and mineral processing operations",
      "Coal, cement, and aggregate handling",
      "Truck loading/unloading zones",
      "Any process requiring controlled moisture without over-wetting"
    ],
    collaborator: {
      name: "Dust Solutions Inc. (DSI)",
      url: "https://nodust.com/solutions/nesco-solutions/"
    }
  },
  {
    id: 26,
    name: "Smart Guards (with Interlocks)",
    slug: "smart-guards-with-interlocks",
    category: "Smart Guards",
    material: "High-Grade MS with Powder-Coated Finish",
    shortDescription: "Industrial safety enclosure with a mesh guard and interlock system that automatically cuts machine power when the door is opened. Designed to prevent unauthorized access while ensuring operator safety without interrupting controlled operations.",
    image: "https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/gt8miqmb_Smart%20Guards%20%28with%20Interlocks%29%20-%20Stallion%20Bulktech.png",
    features: [
      "Integrated safety interlock system (auto power cut on door opening)",
      "Heavy-duty modular MS construction",
      "High-visibility welded mesh panels",
      "Precision-aligned door with secure locking",
      "Corrosion-resistant powder-coated finish",
      "LOTO (Lockout/Tagout) compatible design",
      "Easy installation and low maintenance",
      "Customizable size, layout, and configurations"
    ],
    applications: [
      "CNC machines and robotic cells",
      "Conveyor and material handling systems",
      "Press machines and heavy equipment",
      "Packaging and automation lines",
      "Manufacturing safety zones"
    ]
  }
];

export const keyBenefits = [
  "Extends equipment lifespan by reducing wear, abrasion, and external damage",
  "Controls dust exposure at critical zones, improving plant safety and visibility",
  "Reduces maintenance frequency and unplanned downtime across operations",
  "Engineered for high-load, high-abrasion industrial environments",
  "Improves operational efficiency without restricting access or workflow",
  "Built using durable, wear-resistant, and corrosion-resistant materials",
  "Designed for stability, minimizing vibration and mechanical stress",
  "Custom-engineered for different machinery, layouts, and site conditions",
  "Suitable for mining, cement, power, and bulk material handling industries",
  "Supports compliance with industrial safety and environmental standards"
];

export const servicesContent = {
  title: "Manufacturing | Supply | Service",
  description: "Beyond manufacturing, Stallion provides full-cycle execution: site evaluation, custom engineering, on-site installation, and ongoing service. Effective solutions start with understanding the equipment, identifying wear points and dust-exposure zones, and designing a solution that extends machine life while keeping operations efficient and compliant.",
  processTitle: "To Develop The Most Effective Solutions, We will:",
  process: [
    "Visit your plant site",
    "Meet in person with the user to discuss an overview of the policy",
    "Visit the plant along with your engineer",
    "Identify pinch points, accident-prone areas, wear zones, and dust exposure points to define guarding, wear protection, and dry fog requirements",
    "Take the necessary measurement, data, and take the required pictures with permission",
    "Design the product solutions based on the site visit, measurements, and pictures taken during the visit",
    "Discuss the policy with the user and recommend the upgrades",
    "Submit the detailed evaluation report showing the recommended solutions for assessment areas",
    "Highlight the possible results by using the suggested solutions",
    "Submit the detailed quote for the suggested products"
  ],
  benefits: [
    "Risk Identification and its Management",
    "Cost Projection and Comparison against the potential risk",
    "Customized Guarding designs and fabrication",
    "Identification of the solution which can minimize workplace accidents",
    "Development of a stronger understanding of the standardized and compliant safety guarding system",
    "Termination of the ineffective and non-compliant safety guarding system and development of an effective safety guarding policy"
  ]
};
